import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { MAX_TEXT_WIDTH, TITLE_MARGIN_BOTTOM } from './metadata.constants';

export const defaultContext = makeDefaultStylingContext();

export const genericTextStyle = {
  maxLines: 1,
  textBaseline: 'bottom',
  verticalAlign: 'middle',
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;
  const titleFont = getFont(FONT.KINSHASA_1, screenSize);
  const extraTitleFont = getFont(FONT.OTTAWA_1, screenSize);
  const wordWrapWidth = MAX_TEXT_WIDTH[screenSize];

  return {
    w: wordWrapWidth,
    h: titleFont.lineHeight + TITLE_MARGIN_BOTTOM[screenSize] + extraTitleFont.lineHeight,
    ExtraTitle: {
      mountY: 1,
      text: {
        wordWrapWidth,
        ...genericTextStyle,
        ...extraTitleFont,
      },
    },
  };
};
